// extracted by mini-css-extract-plugin
module.exports = {"title":"acesso_title__24f8Q","pDesc":"acesso_pDesc__1UxOp","box":"acesso_box__AzbI5","button":"acesso_button__2xmXi","desc":"acesso_desc__3vo9h"};